import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LL_H_C, ProtoComponent, Show, TS_Toggler } from '@nu-art/thunderstorm-frontend/index';
import { Component_SubHeader, ConfigKeyFE_DiseasesTagId, Dialog_VariableEditor, ModuleFE_Variable, WarningDialog } from '@app/hcs-frontend';
import './Page_DiseaseProfile_Header.scss';
import { DPDropDowns } from '../../shared-components/index.js';
import { renderDpIcon } from '../../renderers/index.js';
import { Dialog_DiseaseProfileComparator, Dialog_DiseaseProfileEditor } from '../../dialogs/index.js';
import { ICONS } from '@app/styles';
import { asArray, exists } from '@nu-art/ts-common';
import { dispatch_onDiseaseProfilesShowErrorAlertsUpdated, ModuleFE_DiseaseProfile } from '../../../_entity.js';
import { ModuleFE_Workspace } from '@nu-art/ts-workspace-frontend/index';
import { Component_FocusedEntityRef } from '@nu-art/ts-focused-object-frontend/components/Component_FocusedEntityRef';
import { DBDef_DiseaseProfile } from '@app/dp-shared';
export class Page_DiseaseProfile_Header extends ProtoComponent {
    // ######################### Life Cycle #########################
    __onDiseaseProfileUpdated = (...params) => {
        const dps = asArray(params[1]);
        const currentDP = dps.find(dp => dp._id === this.state.selectedDiseaseProfileId);
        if (currentDP)
            //If the current DP was updated, re-render
            this.forceUpdate();
    };
    static defaultProps = {
        keys: ['selected'],
    };
    deriveStateFromProps(nextProps, state) {
        state.selectedDiseaseProfileId = this.getQueryParam('selected', {})[DBDef_DiseaseProfile.dbKey];
        return state;
    }
    // ######################### Logic #########################
    onDiseaseProfileSelected = (disease) => {
        //Picked same disease
        if (disease._id === this.state.selectedDiseaseProfileId)
            return;
        const selected = { ...this.getQueryParam('selected', {}) };
        selected[DBDef_DiseaseProfile.dbKey] = disease._id;
        return this.setQueryParam('selected', selected);
        //FIXME: (12/05/2024) the whole "stop before actually picking if we already have a selected item"
        // simply does not work, the dropdown shows the new item anyway and doesn't return to the
        // old one on cancel.
        // This should be a TS_Dropdown functionality, for now i'm disabling this feature.
        // //First disease picked
        // if (!this.state.selectedDiseaseProfileId) {
        // 	selected[DBDef_DiseaseProfile.dbKey] = disease._id;
        // 	return this.setQueryParam('selected', selected);
        // }
        //
        //
        // //Picking new disease
        // WarningDialog.show({
        // 	title: 'Switch Disease',
        // 	executeButtonText: 'Switch',
        // 	warningMessages: ['You are about to switch diseases', 'Are you sure?'],
        // 	onConfirm: () => {
        // 		selected[DBDef_DiseaseProfile.dbKey] = disease._id;
        // 		this.setQueryParam('selected', selected);
        // 	},
        // 	onCancel: () => {
        // 		this.forceUpdate();
        // 	}
        // });
    };
    onCleanWorkspace = () => {
        WarningDialog.showDelete({
            title: 'Clean Disease Profile Workspace',
            executeButtonText: 'Clean',
            warningMessages: ['Delete disease profile workspace?'],
            onConfirm: async () => {
                const keys = ['disease-profiles', 'disease-profile-var-list', 'disease-profile-likelihood'];
                for (const key of keys) {
                    await ModuleFE_Workspace.deleteWorkspaceByKey(key);
                }
                location.reload();
            }
        });
    };
    // ######################### Render #########################
    renderDropdown() {
        const selectedDP = ModuleFE_DiseaseProfile.cache.unique(this.state.selectedDiseaseProfileId);
        return _jsx(DPDropDowns.DiseaseProfile, { selected: selectedDP, onSelected: this.onDiseaseProfileSelected, sortBy: [(dp) => dp.label.toLowerCase()], renderer: item => {
                const variable = ModuleFE_Variable.cache.unique(item.variableId);
                return _jsxs("div", { className: 'disease-node', children: [_jsx("div", { className: 'disease-node__initials-container', children: renderDpIcon(item) }), _jsx("div", { className: 'disease-node__label', children: item.label ?? variable?.name ?? 'Name not found' })] });
            } });
    }
    renderDiseaseComparatorButton = () => {
        if (!this.state.selectedDiseaseProfileId)
            return;
        const dp = ModuleFE_DiseaseProfile.cache.unique(this.state.selectedDiseaseProfileId);
        if (!dp) {
            this.logError('Will not render disease profile comparator button', `Could not get DP for id ${this.state.selectedDiseaseProfileId}`);
            return;
        }
        return _jsx(Button, { onClick: () => {
                Dialog_DiseaseProfileComparator.show([dp]);
            }, children: "Compare DP With" });
    };
    renderButtons() {
        const selectedDP = ModuleFE_DiseaseProfile.cache.unique(this.state.selectedDiseaseProfileId);
        return _jsx(LL_H_C, { className: 'disease-dropdown__buttons', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: exists(selectedDP), children: _jsx(ICONS.edit.component, { onClick: () => Dialog_DiseaseProfileEditor.show(selectedDP) }) }), _jsxs(Show.If, { condition: true, children: [_jsx("div", { className: 'add-disease-profile', onClick: () => Dialog_DiseaseProfileEditor.show(), children: "+" }), _jsx(TS_Toggler, { options: ['Show Alerts', 'Ignore Alerts'], alwaysSelected: true, defaultValue: ModuleFE_DiseaseProfile.showDiseaseProfileErrorAlerts.get() ? 'Show Alerts' : 'Ignore Alerts', onValueChange: (val) => {
                                    ModuleFE_DiseaseProfile.showDiseaseProfileErrorAlerts.set(val === 'Show Alerts');
                                    dispatch_onDiseaseProfilesShowErrorAlertsUpdated.dispatchUI();
                                }, value: ModuleFE_DiseaseProfile.showDiseaseProfileErrorAlerts.get() ? 'Show Alerts' : 'Ignore Alerts' }), this.renderDiseaseComparatorButton()] }), _jsx(Show.If, { condition: exists(selectedDP), children: selectedDP?._id && _jsx(Component_FocusedEntityRef, { focusedEntities: [{ dbKey: DBDef_DiseaseProfile.dbKey, itemId: selectedDP._id }] }) }), _jsx(Show.If, { condition: true, children: _jsx(Button, { variant: 'primary', style: { marginLeft: 'auto' }, onClick: () => {
                                const diseaseTagId = ConfigKeyFE_DiseasesTagId.get();
                                Dialog_VariableEditor.show(diseaseTagId);
                            }, children: "Add Variable" }) })] }) });
    }
    render() {
        return _jsx(Component_SubHeader, { cleanWorkspace: this.onCleanWorkspace, children: _jsxs(LL_H_C, { className: 'disease-dropdown', children: [this.renderDropdown(), this.renderButtons()] }) });
    }
}
//# sourceMappingURL=Page_DiseaseProfile_Header.js.map